export const listProductLicenses = /* GraphQL */ `
  query ListProductLicenses($input: ListProductLicensesInput!) {
    listProductLicenses(input: $input) {
      items {
        id
        sk
        workspaceId
        schemaVersion

        config
        createdAt
        resource {
          id
          sk
          workspaceId
          schemaVersion
          name
          tags {
            key
            type
            value
          }
          createdAt
          updatedAt
        }
        updatedAt
      }
      nextToken
    }
  }
`;

export const putProductLicense = /* GraphQL */ `
  mutation PutProductLicense($input: CreateProductLicenseInput!) {
    putProductLicense(input: $input) {
      id
      sk
    }
  }
`;

export const deleteProductLicense = /* GraphQL */ `
  mutation DeleteProductLicense($input: DeleteProductLicenseInput!) {
    deleteProductLicense(input: $input) {
      id
      sk
    }
  }
`;
